import { TranslationLanguageCode } from '@/enums/translation'

export function getTranslationLanguageCodeByCountryCode (countryCode) {
  // NOTE: 目前 API 沒有提供 country_code Enum，這些資料是從 DB 撈出來的
  switch (countryCode) {
    case 'TW':
      return TranslationLanguageCode.TW
    case 'JP':
      return TranslationLanguageCode.JP
    case 'TH':
      return TranslationLanguageCode.TH
    case 'MY':
    case 'PH':
    case 'SG':
    default:
      return TranslationLanguageCode.EN
  }
}
